/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {	
  $("body").on('click','.faq_title',function (e) {	
    e.preventDefault();
    $(".faq_title").removeClass("active");				
    $(".faq_content").slideUp();		
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active");
    }
  });
  
   $(".tab-view").each(function(){
    $(this).find(".tab_content").hide();
    $(this).find(".tab_content:first").show();
  }); 
  
  /* if in tab mode */
  $("ul.tabs li").click(function(e) {
	e.preventDefault();
    $(this).closest(".tab-view").find(".tab_content").hide();
    var activeTab = $(this).attr("rel"); 
    $("#"+activeTab).fadeIn();		

    $(this).closest(".tab-view").find("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(this).closest(".tab-view").find(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  });

   $(".tab_drawer_heading").click(function() { 
    $(this).closest(".tab-view").find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel"); 
    if ($(this).hasClass("d_active")) {
      $("#"+d_activeTab).fadeOut();
      $(this).removeClass("d_active");
      $("ul.tabs li[rel^='"+d_activeTab+"']").removeClass("active");
    } else {
      $("#"+d_activeTab).fadeIn();

      $(this).closest(".tab-view").find(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");

      $(this).closest(".tab-view").find("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    }
  });
  /* Extra class "tab_last" 
	   to add border to right side
	   of last tab */
  $('ul.tabs li').last().addClass("tab_last");
  /* TABS ENDS */
  
  
  $('.play_icon').on('click',function(){
    if($(this).closest('.video_wrapper').find('.play_icon').attr('data-click') == 1) {
      $(this).attr('data-click', 0)
      $(this).closest('.video_wrapper').find('.video--tag')[0].pause();
      $(this).closest('.video_wrapper').find('.play_icon').css("opacity", "1");
    } else {
      $(this).closest('.video_wrapper').find('.play_icon').attr('data-click', 1)
      $(this).closest('.video_wrapper').find('.video--tag')[0].play();
      $(this).closest('.video_wrapper').find('.play_icon').css("opacity", "1");
     $(this).closest('.video_wrapper').find('.play_icon').css("opacity", "0");
    }
  });

  $('.play_icons').on('click',function(){
      $(this).closest('.blog_card_img').find('.play_icons').attr('data-click', 1)
      $(this).closest('.blog_card_img').find('.video--tag')[0].play();
      $(this).closest('.blog_card_img').find('.play_icons').css("opacity", "1");
      $(this).closest('.blog_card_img').find('.play_icons').css("opacity", "0");
      $(this).closest('.blog_card_img').addClass('active');
  });
   $('.blog_card_img .video--tag').on('click',function(){
      $(this).closest('.blog_card_img .play_icons').attr('data-click', 0)
      $(this).closest('.blog_card_img').find('.video--tag')[0].pause();
      $(this).closest('.blog_card_img').find('.play_icons').css("opacity", "1");
      $(this).closest('.blog_card_img').removeClass('active');
  });
  
  function dropDownCreate() {
    if ($(window).width() < 960) {
      var list = $('.js-dropdown-list');
      var link = $('.js-link');
      link.click(function(e) {
        e.preventDefault();
        list.slideToggle(200);
        link.toggleClass('active_link');
      });
      list.find('li').click(function() {
        var text = $(this).html();
        link.html(text);
        list.slideToggle(200);
      });
    }
  }

  // window.addEventListener('resize', function(event) {
  //   dropDownCreate();
  // });

  dropDownCreate();
  
  var screenLoading = false;
  var screenDelay = 100;

  function pInfScrExecute() {
    var loadingImage,loadingmore;
    pInfScrNode = $('.main-blog-btn').last();
    pInfScrmore = $('.main-blog-btn').last();
    pInfScrURL = $('.main-blog-btn a').last().attr("href");
    if(!screenLoading && pInfScrNode.length > 0  && pInfScrNode.css('display') != 'none' ) {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          screenLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src="https://cdn.shopify.com/s/files/1/0573/7820/9836/files/loading.gif?v=1653148769" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
          pInfScrmore.hide();
        },
        success: function(data) {
          pInfScrNode.next().remove();
          pInfScrmore.next().remove();
          var filteredData = $(data).find("#blog-grid").html();
          $('#blog-grid').append(filteredData);
          loadingImage.remove();
          screenLoading = false;
        },
        dataType: "html"
      });

    }
  }
  
  $('body').on('click', '.main-blog-btn', function(e){
    e.preventDefault();
    if(document.getElementById("blog-grid")){
      setTimeout(function(){
        pInfScrExecute();
      }, screenDelay);
      if( $(document).height() - 1500 > $(document).scrollTop() + $(window).height() ) {
        screenDelay = 100;
      }
    }
  });

  if (window.location.href.indexOf('?tab=') > 0) {
    function getUrlVars()    {
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for(var i = 0; i < hashes.length; i++)       {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    }

    var first = getUrlVars()["tab"];
    var mydata = first.split("%20");
    var myparavalue = mydata.join(" ");
    myparavalue = myparavalue.replace(/_/g, '&');
    $('.tabs [rel="'+myparavalue+'"]').trigger('click');
  }


  function initSlick() {
    if (window.innerWidth < 1024) {
      if (!$('.how-it-works-steps-wrap').hasClass('slick-initialized')) {
        $('.how-it-works-steps-wrap').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          autoplay: false,
          arrows: true,
          prevArrow: $('.left-arrow'),
          nextArrow: $('.right-arrow')
        });
      }
    } else {
      if ($('.how-it-works-steps-wrap').hasClass('slick-initialized')) {
        $('.how-it-works-steps-wrap').slick('unslick');
      }
    }
  }
  
  $(document).ready(function() {
    initSlick();
    $(window).on('resize', initSlick);
  });
  
});